import { render, staticRenderFns } from "./ManagementActivityCardNew.vue?vue&type=template&id=5abb67f1&scoped=true"
import script from "./ManagementActivityCardNew.vue?vue&type=script&lang=ts"
export * from "./ManagementActivityCardNew.vue?vue&type=script&lang=ts"
import style0 from "./ManagementActivityCardNew.vue?vue&type=style&index=0&id=5abb67f1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abb67f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5abb67f1')) {
      api.createRecord('5abb67f1', component.options)
    } else {
      api.reload('5abb67f1', component.options)
    }
    module.hot.accept("./ManagementActivityCardNew.vue?vue&type=template&id=5abb67f1&scoped=true", function () {
      api.rerender('5abb67f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/ManagementActivityCardNew.vue"
export default component.exports